import React from 'react';
import Lock from 'wix-ui-icons-common/on-stage/Lock';
export const withReadonlySuffix = (readonly) => {
    if (readonly) {
        return React.createElement(Lock, null);
    }
    return undefined;
};
//# sourceMappingURL=withReadonlySuffix.js.map